import { useState } from 'react';
import { productChannel } from '../platform/channel';
export function problemReportBody(path: string, version: string, channel: string): string {
  return `앱 버전: ${version}\n화면: ${path.split('?')[0]}\n기기 종류: ${channel === 'ait' ? '토스 앱' : '웹 브라우저'}\n\n문제가 생긴 상황을 적어 주세요. 이름·연락처·학습 내용·사진·복구 키는 넣지 마세요.`;
}
export function ProblemReport() {
  const [message, setMessage] = useState<string>();
  const [show, setShow] = useState(false);
  const body = problemReportBody(
    location.pathname,
    import.meta.env['VITE_BUILD_VERSION'] ?? 'local',
    productChannel,
  );
  const subject = `[회독루프 오류] ${location.pathname}`;
  const address = 'support@munops.com';
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(`${address}\n제목: ${subject}\n${body}`);
      setMessage('주소와 문의 초안을 복사했어요.');
    } catch {
      setShow(true);
      setMessage('아래 내용을 직접 복사해 주세요.');
    }
  };
  return (
    <section className="pn-problem-report">
      <h2>문제 알리기</h2>
      <p>화면 이름·앱 버전·웹/토스 종류만 초안에 넣어요.</p>
      {productChannel === 'web' ? (
        <a
          className="pn-small-button"
          href={`mailto:${address}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`}
        >
          메일 초안 열기
        </a>
      ) : null}
      <button className="pn-small-button" onClick={() => void copy()}>
        주소·내용 복사
      </button>
      {message ? <p role="status">{message}</p> : null}
      {show ? (
        <textarea aria-label="문의 초안" readOnly value={`${address}\n제목: ${subject}\n${body}`} />
      ) : null}
    </section>
  );
}
